// AXIS ZERO - Skin Manager (Stub)
// Placeholder for future skin/customization system

export class SkinManager {
  constructor() {
    this.currentSkin = 'default';
    this.unlockedSkins = ['default'];
    this.skins = {
      default: {
        id: 'default',
        name: 'Neon Performer',
        bodyColor: '#00F0FF',
        glowColor: 'rgba(0, 240, 255, 0.6)',
        eyeColor: '#FFFFFF',
        trailColor: '#00F0FF',
        unlocked: true,
        price: 0,
      },
      // Future skins to be added:
      // magenta: { ... },
      // gold: { ... },
      // rainbow: { ... },
    };
  }

  getCurrentSkin() {
    return this.skins[this.currentSkin];
  }

  setSkin(skinId) {
    if (this.unlockedSkins.includes(skinId)) {
      this.currentSkin = skinId;
      return true;
    }
    return false;
  }

  unlockSkin(skinId) {
    if (!this.unlockedSkins.includes(skinId) && this.skins[skinId]) {
      this.unlockedSkins.push(skinId);
      return true;
    }
    return false;
  }

  getAvailableSkins() {
    return Object.values(this.skins);
  }

  getUnlockedSkins() {
    return this.unlockedSkins.map(id => this.skins[id]);
  }

  // Stub for purchase system
  purchaseSkin(skinId, currency) {
    // To be implemented with actual monetization
    console.log(`[SkinManager] Purchase stub: ${skinId} for ${currency}`);
    return false;
  }
}

export default SkinManager;
